export enum HomeUsage {
  MainResidence = "Main Residence",
  SeasonalResidence = "Seasonal Residence",
  HomeIsVacant = "Home is Vacant",
}
